import { BaseContainerModel } from '../../base-container.model';
import { bl_fi_mst_label_link_RowClass } from '../../../dbschema';
import { bl_fi_mst_label_hdr_login_subject_link_RowClass } from '../../../dbschema/bl_fi_label_hdr_login_subject_link.model';

export class LabelHdrLoginSubjectLinkContainerModel extends BaseContainerModel {
  bl_fi_mst_label_hdr_login_subject_link: bl_fi_mst_label_hdr_login_subject_link_RowClass = new bl_fi_mst_label_hdr_login_subject_link_RowClass();
}
